<template>
    <div class="layout-page-title">
        <h1 class="page-title">
            {{ $t('MENU.SETTINGS')}} <!--Settings-->
        </h1>

        <nav class="navigation-tab">
            <h2 class="title"></h2>

            <router-link tag="button" to="/settings/whitelist" v-bind:class="{'selected' : menu==1}" class="tab-item">{{ $t('SETTING.TAB_NM.WHITELIST')}}<!--차단목록--></router-link>
            <router-link tag="button" to="/settings/category" v-bind:class="{'selected' : menu==2}" class="tab-item">{{ $t('SETTING.TAB_NM.CATEGORY')}}<!--카테고리 라벨--></router-link>
            <router-link tag="button" to="/settings/region" v-bind:class="{'selected' : menu==3}" class="tab-item">{{ $t('SETTING.TAB_NM.REGION')}}<!--카테고리 라벨--></router-link>
<!--            <router-link tag="button" to="/settings/" v-bind:class="{'selected' : menu==3}" class="tab-item">{{ $t('SETTING.ACCOUNT.TAB_NM')}}&lt;!&ndash;카테고리 라벨&ndash;&gt;</router-link>-->
<!--            <router-link tag="button" to="/settings/" v-bind:class="{'selected' : menu==4}" class="tab-item">{{ $t('SETTING.EXTENSION.TAB_NM')}}&lt;!&ndash;카테고리 라벨&ndash;&gt;</router-link>-->
        </nav>
    </div>
</template>

<script>

    export default {
        name: 'settings-header',
        props: {
            menu: Number | String
        },
        data: function() {
            return {

            }
        },
        methods: {
        }

    }
</script>




// WEBPACK FOOTER //
// src/components/settings/settingsHeader.vue